<div
  class="card"
  *appIsGranted="['OTHERS', 'OTHERS_KEEP_ALIVE_LAST_FILE', 'READ']"
>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-sm-between">
        <h6>Pesquisa Keep Alive File</h6>
        <div
          *appIsGranted="['OTHERS', 'OTHERS_KEEP_ALIVE_LAST_FILE', 'CREATE']"
        >
          <button
            type="button"
            class="btn btn-primary btn-sm"
            style="margin-right: 5px"
            (click)="openModal(modalInsertNewCommand)"
          >
            Adicionar<br />seriais na lista
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card align-items-center" *ngIf="circularProgressiveWait">
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <div class="card-body">
      <!-- Nav tabs -->
      <ul
        ngbNav
        #customNav="ngbNav"
        [activeId]="1"
        class="nav nav-tabs nav-tabs-custom"
      >
        <li [ngbNavItem]="1" (click)="getLastFile()">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Último Arquivo</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabLastFile"></ng-template>
          </ng-template>
        </li>
        <li
          [ngbNavItem]="2"
          (click)="getDevicesCanDownload()"
          *appIsGranted="[
            'OTHERS',
            'OTHERS_KEEP_ALIVE_DEVICES_DOWNLOAD',
            'READ'
          ]"
        >
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Dispositivos que podem baixar</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template
              [ngTemplateOutlet]="TabDevicesCanDownload"
            ></ng-template>
          </ng-template>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content p-3 text-muted">
        <div [ngbNavOutlet]="customNav"></div>
      </div>
    </div>
  </div>

  <!-- Tab LastFiles-->
  <ng-template #TabLastFile>
    <div class="card overflow-auto">
      <div class="card-header">
        <h6>
          id: {{ lastFileInfo.id }} - data do arquivo: {{ lastFileInfo.data }} -
          crc:
          {{ lastFileInfo.crc }}
        </h6>
      </div>

      <div class="card-body">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">serial</th>
              <th class="text-center" scope="col">loraId</th>
              <th class="text-center" scope="col">actionId</th>
              <th class="text-center" scope="col">actionParam</th>
              <th class="text-center" scope="col">commandSeq</th>
              <th class="text-center" scope="col">dataExpiração</th>
              <th class="text-center" scope="col">ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lastFile | paginate: { itemsPerPage: itensPorPagina, currentPage: arquivosPaginalAtual }; let i = index">
              <td class="text-center" scope="row">{{ item.serial }}</td>
              <td class="text-center" scope="row">{{ item.loraID }}</td>
              <td class="text-center" scope="row">{{ item.actionID }}</td>
              <td class="text-center" scope="row">{{ item.actionParam }}</td>
              <td class="text-center" scope="row">{{ item.commandSeq }}</td>
              <td class="text-center" scope="row">
                {{ item.expirationDateTime }}
              </td>
              <td class="text-center" scope="row">
                <i
                  *appIsGranted="[
                    'OTHERS',
                    'OTHERS_KEEP_ALIVE_LAST_FILE',
                    'DELETE'
                  ]"
                  class="fa fa-trash"
                  aria-hidden="true"
                  style="color: red"
                  (click)="removeCommand(item.serial, item.loraID)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Controles de Paginação -->
        <div>
          <button (click)="paginaAnterior()" class="btn btn-primary"  [disabled]="arquivosPaginalAtual === 1">Anterior</button>
          <span>Página {{ arquivosPaginalAtual }} de {{ totalPaginas }}</span>
          <button (click)="proximaPagina()" class="btn btn-primary" [disabled]="arquivosPaginalAtual === totalPaginas">Próxima</button>
        </div>
        <p>
          Total: {{ lastFile.length }}
        </p> 
      </div>
    </div>
  </ng-template>

  <!-- Tab Devices Can Download-->
  <ng-template #TabDevicesCanDownload>
    <div class="card overflow-auto">
      <div class="card-header">
        <button
          *appIsGranted="[
            'OTHERS',
            'OTHERS_KEEP_ALIVE_DEVICES_DOWNLOAD',
            'CREATE'
          ]"
          class="btn btn-sm btn-primary"
          (click)="openModal(modalInsertNewDeviceCanDownload)"
        >
          Adicionar seriais
        </button>
      </div>

      <div class="card-body">
        <table
          class="table table-fit table-bordered table-hover"
          style="inline-size: fit-content"
        >
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">fileId</th>
              <th class="text-center" scope="col">Freq</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filesIdsCount.fileId; let i = index">
              <td class="text-center" scope="row">
                {{ filesIdsCount.fileId[i] }}
              </td>
              <td class="text-center" scope="row">
                {{ filesIdsCount.count[i] }}
              </td>
            </tr>
          </tbody>
        </table>
        
        <input 
            type="text" 
            class="form-control mb-2"
            placeholder="Pesquisar serial..."
            [(ngModel)]="filtroSerial"
            (ngModelChange)="onFiltroChange()">
        <table class="table table-fit table-bordered table-hover">
          <thead class="table-primary">
            <tr>
              <th class="text-center" scope="col">#</th>
              <th class="text-center" scope="col">Serial</th>
              <th class="text-center" scope="col">Último arquivo Redis</th>
              <th class="text-center" scope="col">Data próximo download</th>
              <th class="text-center" scope="col">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let serial of devicesCanDownload | filterSerial : filtroSerial | paginate: { itemsPerPage : itensPorPaginaDispositivos, currentPage: dispositivosPaginalAtual }; let i = index;">
              <td class="text-center" scope="row">
                  {{ i + 1 + (dispositivosPaginalAtual - 1) * itensPorPaginaDispositivos }}
                    </td>
              <td class="text-center" scope="row">{{ serial.serial }}</td>
              <td class="text-center" scope="row">
                {{ serial.lastFile }} - {{ serial.date }}
              </td>
              <td class="text-center" scope="row">{{ serial.timer }}</td>
              <td class="text-center" scope="row">
                <i
                  *appIsGranted="[
                    'OTHERS',
                    'OTHERS_KEEP_ALIVE_DEVICES_DOWNLOAD',
                    'DELETE'
                  ]"
                  class="fa fa-trash"
                  aria-hidden="true"
                  style="color: red"
                  (click)="removeDeviceCandDownload(serial.serial)"
                ></i>

                <ng-container *ngIf="serial.timer != ''">
                  <button
                    *appIsGranted="[
                      'OTHERS',
                      'OTHERS_KEEP_ALIVE_DEVICES_DOWNLOAD',
                      'DELETE'
                    ]"
                    class="m-3 btn btn-sm btn-warning"
                    (click)="zeroTimerDeviceCandDownload(serial.serial)"
                  >
                    Zerar timer
                  </button>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Controles de Paginação -->
        <div>
          <button (click)="paginaAnteriorDispositivos()" class="btn btn-primary"  [disabled]="dispositivosPaginalAtual === 1">Anterior</button>
          <span>Página {{ dispositivosPaginalAtual }} de {{ totalPaginasDispositivos }}</span>
          <button (click)="proximaPaginaDispositivos()" class="btn btn-primary" [disabled]="dispositivosPaginalAtual === totalPaginasDispositivos">Próxima</button>
        </div>
        <p>
          Total: {{ devicesCanDownload.length }}
        </p> 
      </div>
    </div>
  </ng-template>

  <!-- Dialog Insert Item -->
  <ng-template #modalInsertNewCommand let-modal>
    <div class="modal-header">
      <h5 class="modal-title mt-0">Adicionar seriais na lista</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-serial">Serial</span>
        <input
          name="serial"
          placeholder="Inserir os seriais separados por ;"
          [(ngModel)]="newCommand.serial"
          type="text"
          class="form-control"
          required
          aria-describedby="inputGroup-serial"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-loraid">LoraId</span>
        <input
          name="loraid"
          placeholder="Inserir o LoraID dos seriais respectivamente separados por ;"
          [(ngModel)]="newCommand.loraid"
          type="text"
          class="form-control"
          required
          aria-describedby="inputGroup-loraid"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-comando">Comando </span>
        <select
          name="commandType"
          [(ngModel)]="newCommand.p2pTipoComando"
          type="number"
          class="form-control"
          aria-describedby="inputGroup-commandType"
        >
          <option *ngFor="let command of commandP2PType" [value]="command.id">
            {{ command.nome }}
          </option>
        </select>
      </div>
      <ng-container *ngIf="verificarSeTemParametro(newCommand.p2pTipoComando)">
        <ng-container *ngIf="newCommand.p2pTipoComando == 9">
          <div class="col input-group input-group-sm mb-3">
            <span class="input-group-text" id="inputGroup-setParam"
              >Comando</span
            >
            <input
              class="form-control"
              type="text"
              [placeholder]="
                returnPlaceholderSetParamCommandP2P(newCommand.p2pTipoComando)
              "
              [(ngModel)]="newCommand.p2pParam"
            />
          </div>
        </ng-container>
        <ng-container *ngIf="newCommand.p2pTipoComando != 9">
          <ng-container *ngIf="newCommand.p2pTipoComando == 2">
            <div class="row">
              <div class="col input-group input-group-sm mb-3">
                <span class="input-group-text" id="inputGroup-outputControl"
                  >Porta Saída</span
                >
                <input
                  *ngIf="newCommand.p2pTipoComando == 2"
                  class="form-control"
                  type="number"
                  step="1"
                  min="1"
                  [(ngModel)]="newCommandOutputControlPortAux"
                />
              </div>
              <div class="col card">
                {{
                  newCommandOutputControlPortAux < 10
                    ? "0" + newCommandOutputControlPortAux
                    : newCommandOutputControlPortAux
                }}{{ newCommand.p2pParam == "0" ? "02" : "01" }}
              </div>
            </div>
          </ng-container>
          <div class="input-group input-group-sm mb-3">
            <span class="input-group-text" id="inputGroup-color"
              >Parametro
            </span>
            <select [(ngModel)]="newCommand.p2pParam" class="form-control">
              <option value="1" selected>Ativar</option>
              <option value="0">Desativar</option>
            </select>
          </div>
        </ng-container>
      </ng-container>

      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-local"
          >Data de expiração do comando
        </span>
        <input
          name="timeout"
          [(ngModel)]="newCommand.p2pTimeout"
          type="datetime-local"
          class="form-control"
          aria-describedby="inputGroup-timeout"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-description"
          >Forçar envio</span
        >
        <input
          type="checkbox"
          name="forceSend"
          [(ngModel)]="newCommand.forcarEnvio"
          value="true"
        />
      </div>
      <!-- ADICIONAR BLOQUEIO PARA PARAMETROS NAO CONFIGURADOS -->
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="
          newCommand.serial.length < 1 && newCommand.serial.length < 1
        "
        (click)="addCommand(); modal.dismiss('Cross click')"
      >
        Adicionar
      </button>
      <label *ngIf="newCommand.serial.length < 1" class="text-danger ms-3">
        Inserir o número de série</label
      >
      <label *ngIf="newCommand.loraid.length < 1" class="text-danger ms-3">
        Inserir o loraid dos itens</label
      >
    </div>
  </ng-template>

  <!-- Dialog New Device Can Download -->
  <ng-template #modalInsertNewDeviceCanDownload let-modal>
    <div class="modal-header">
      <h5 class="modal-title mt-0">
        Incluir novo serial na lista para baixar arquivos
      </h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-plate">Serial</span>
        <input
          name="serial"
          placeholder="Inserir os seriais separados por ;"
          [(ngModel)]="newSerialCanDownload"
          type="text"
          class="form-control"
          required
          aria-describedby="inputGroup-serial"
        />
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="newSerialCanDownload.length < 1"
        (click)="addDeviceCanDownload(); modal.dismiss('Cross click')"
      >
        Adicionar
      </button>
      <label *ngIf="newCommand.serial.length < 1" class="text-danger ms-3">
        Inserir os números de série</label
      >
    </div>
  </ng-template>
</div>
